<template>
  <vx-card class="mb-4">
    <div class="text-right" v-if="share_permission">
      <vs-button
        v-if="selectedGrades.length > 1" 
        @click="studentReportShareBulk(selectedGrades)"
      >
        Bulk Share
      </vs-button>
    </div>

    <ag-grid-vue 
      ref="agGridTable"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :style="{ minHeight: student_grade_list.length * 48 + 75 + 'px' }"
      :animateRows="true"
      :floatingFilter="false"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
      :columnDefs="gradeListColumnDefs"
      :rowData="student_grade_list"
      rowSelection="multiple"
      @row-selected="onRowSelected"
      :gridOptions="gridOptions"
    />

    <vs-row class="mt-10">
      <pagination
        style="float: right"
        :meta="student_grade_list_meta"
        @page-change="handlePageChange"
      />
    </vs-row>

    <div class="full-cstm-sidebar mt-107" :class="{'open': previewSidebar}">
      <div class="mt-6 flex items-center justify-between px-6">
          <h4>Preview</h4>
          <feather-icon icon="XIcon" class="cursor-pointer" @click="closeGradebookSidebar" />
      </div>
      <vs-divider class="mb-0" />
          
      <div class="p-6 pt-2 sidebar-scrollable-form class_report_holder">
        <class-report-card v-if="payloadForSidebar" :payloadForSidebar="payloadForSidebar" />
      </div>
    </div>
  </vx-card>
</template>

<script>
import Vue from 'vue'
import { getGradeList, studentReportShare } from '@/api/classes'
import vSelect from 'vue-select'
import Pagination from '@/components/common/pagination'
import ClassReportCard from './ClassReportCard.vue'
import { AgGridVue } from 'ag-grid-vue'
import StudentGradeFullNameCell from '../table_components/StudentGradeFullNameCell.vue'
import TotalMarksCell from '../table_components/TotalMarksCell.vue'
import GoToGradebookCell from '../table_components/GoToGradebookCell.vue'
import PreviewGradebookCell from '../table_components/PreviewGradebookCell.vue'
import GradebookShareCell from '../table_components/GradebookShareCell.vue'
import MarksEntryCell from '../table_components/MarksEntryCell.vue'

export default {
  name: 'GradeListing',
  props: ['is_archived', 'class_id', 'edit_permission', 'share_permission'],
  components: {
    vSelect,
    Pagination,
    ClassReportCard,
    AgGridVue,
    StudentGradeFullNameCell,
    TotalMarksCell,
    GoToGradebookCell,
    PreviewGradebookCell,
    GradebookShareCell,
    MarksEntryCell
  },
  data () {
    return {
      gridOptions: {},
      gridApi: {},
      customer_id: localStorage.getItem('customer_id'),
      selectedGrades: [],
      student_grade_list: [],
      student_grade_list_meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      previewSidebar: false,
      payloadForSidebar: null,
      permissions: this.edit_permission(),
      gradeListColumnDefs: [
        {
          headerName: '',
          width: 60,
          field: 'isSelected',
          filter: false,
          checkboxSelection: () => {
            return true
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: 'Full Name',
          field: 'full_name',
          cellRendererFramework: Vue.extend(StudentGradeFullNameCell)
        },
        {
          headerName: 'Class Name',
          field: 'class_name'
        },
        {
          headerName: 'Total Marks',
          field: 'final_marks',
          cellRendererFramework: Vue.extend(TotalMarksCell)
        },
        {
          headerName: 'Marks List',
          field: 'marks_entry',
          cellRendererFramework: Vue.extend(MarksEntryCell),
          CellRendererParams: {
            class_id: this.class_id,
            permissions: () => this.edit_permission(),
            is_archived: this.is_archived
          }
        },
        {
          headerName: 'View',
          field: 'view',
          cellRendererFramework: Vue.extend(GoToGradebookCell),
          CellRendererParams: {
            goToGradebook: (data) => this.goToGradebook(data)
          }
        },
        {
          headerName: 'Preview',
          field: 'preview',
          cellRendererFramework: Vue.extend(PreviewGradebookCell),
          CellRendererParams: {
            openGradebookSidebar: (data) => this.openGradebookSidebar(data)
          }
        }
      ]
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    if (this.share_permission) {
      this.gradeListColumnDefs.push({
        headerName: 'Share',
        field: 'share',
        cellRendererFramework: Vue.extend(GradebookShareCell),
        CellRendererParams: {
          studentReportShare: (data) => this.studentReportShare(data)
        }
      })
    }
  },
  methods: {
    async getGradeList (page_no) {
      const payload = { class_id: this.class_id }
      try {
        const response = await getGradeList(this.customer_id, page_no, payload)
        this.student_grade_list = response.data.data.answerslist
        this.student_grade_list_meta = response.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    onRowSelected () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()

      if (selectedNodes) {
        const selectedNode = this.gridApi.getSelectedNodes()
        this.selectedGrades = selectedNode.map((node) => node.data)
      } else {
        this.selectedGrades = []
      }
    },
    handlePageChange (page_no) {
      this.getGradeList(page_no)
    },
    openGradebookSidebar (student_data) {
      if (student_data.final_marks) {
        const  client_user_id = student_data.client_user_id
        const class_id = student_data.class_id
        const user_class_answer_master_id = student_data.id

        const payload = {
          client_user_id,
          class_id,
          user_class_answer_master_id
        }

        this.payloadForSidebar = payload

        this.previewSidebar = true
      } else {
        this.showSuccessMessage('Error', 'Please enter marks from marks entry before proceeding', 'danger')
      }
    },
    closeGradebookSidebar () {
      this.previewSidebar = false
      this.payloadForSidebar = null
    },
    goToGradebook (student_data) {
      // console.log(student_data)

      if (student_data.final_marks) {
        const  client_user_id = student_data.client_user_id
        const class_id = student_data.class_id
        const user_class_answer_master_id = student_data.id

        const payload = {
          client_user_id,
          class_id,
          user_class_answer_master_id
        }

        this.$router.push({ name: 'class_gradebook', params: { payload, class_id, client_user_id } })

      } else {
        this.showSuccessMessage('Error', 'Please enter marks from marks entry before proceeding', 'danger')
      }
    },
    studentReportShareBulk (selectedGrades) {
      selectedGrades.map((x) => {
        this.studentReportShare(x)
      })
    },
    async studentReportShare (student_data) {
      // console.log('student_data', student_data)

      if (!student_data.final_marks) {
        this.showSuccessMessage('Error', 'Please enter marks from marks entry before proceeding', 'danger')
      } else {
        try {
          const gradebook_id = student_data.id

          const payload = {
            id: [gradebook_id]
          }

          const response = await studentReportShare(this.customer_id, payload)
          if (response.status === 200) {
            student_data.shared = 1
            this.showSuccessMessage('Success', 'Gradebook shared with student', 'success')
          }
        } catch (e) {
          this.showSuccessMessage('Error', e.data.message, 'danger')
        }
      }
    }
  }
}
</script>
